// Get elements by class name
const productsOnPage = document.querySelector(".products-onpage")
const loadMoreBtn = document.querySelector(".load-more-btn")
const loadMoreSpinner = document.querySelector(".load-more-spinner")
const productGrid = document.getElementById("product-grid")
const customShowProduct = document.querySelector(".custom-show-product")
const customTotalProduct = document.querySelector(".custom-total-product")
const loadMoreProgressBar = document.querySelector(".load-more-progress-bar")
const swatchesImageChange = document.querySelectorAll(
  ".custom-product-swatches input",
)

const isYotpoRatingMinActive = () => {
  try {
    return !!(
      new URLSearchParams(window.location.search).get("yotpo_rating_min") || ""
    ).trim()
  } catch (_) {
    return false
  }
}

const parseLastPositiveInt = (text) => {
  const matches = String(text || "").match(/\d[\d,]*/g) || []
  const last = matches.length ? matches[matches.length - 1] : ""
  const n = parseInt(String(last).replace(/,/g, ""), 10)
  return Number.isFinite(n) && n > 0 ? n : 0
}

const getLoadedProductItems = () => {
  try {
    if (!productGrid) return []
    return Array.from(productGrid.children || []).filter((el) => {
      if (!(el instanceof HTMLElement)) return false
      if (!el.matches("li.grid__item")) return false
      return !el.classList.contains("daily-deals-injected")
    })
  } catch (_) {
    return []
  }
}

// Initialize variables

let nextUrl = productsOnPage ? productsOnPage.dataset.nextUrl : null

// Function to load more products
const loadMoreProducts = () => {
  if (!nextUrl) return

  // Show spinner, hide load more button
  loadMoreBtn.style.display = "none"
  loadMoreSpinner.classList.remove("hidden")

  // Make AJAX request
  fetch(nextUrl)
    .then((response) => response.text())
    .then((data) => {
      // Hide spinner
      loadMoreSpinner.classList.add("hidden")

      // Create a temporary div to parse the HTML string
      const tempDiv = document.createElement("div")
      tempDiv.innerHTML = data

      // Find new products
      const newProducts = tempDiv.querySelector(".products-onpage")
      if (!newProducts) return

      nextUrl = newProducts.dataset.nextUrl

      // Show load more button if there's more to load
      if (nextUrl) {
        loadMoreBtn.style.display = "inline-flex"
      }

      // Append new products to the existing ones
      productsOnPage.innerHTML += newProducts.innerHTML

      // hide solo swatches
      getLoadedProductItems().forEach((el) => {
        const swatches = el.querySelectorAll(".custom-product-swatches")
        if (swatches.length === 1) swatches[0].style.display = "none"
      })

      // Recount total products
      countTotalProduct()
      initBadges()
      checkProductCardsPromoTextHeight()
    })
    .catch((error) => {
      console.error("Error:", error)
      // Hide spinner and show load more button in case of error
      loadMoreSpinner.style.display = "none"
      loadMoreBtn.style.display = "inline-flex"
    })
    .finally(() => {
      document.dispatchEvent(
        new Event("more:products:loaded", { bubbles: true, composed: true }),
      )
    })
}

// Function to count total products
const countTotalProduct = () => {
  // Rating filter is handled by `custom-filter-facets.js` and can load/append pages.
  // Avoid clobbering the “visible out of total” UI while it is active.
  if (isYotpoRatingMinActive()) return

  const resultCount = getLoadedProductItems().length
  if (customShowProduct) {
    const countContainer =
      document.getElementById("ProductCount") ||
      document.getElementById("ProductCountDesktop")
    customShowProduct.textContent = resultCount
    if (
      !loadMoreBtn ||
      window.getComputedStyle(loadMoreBtn).display === "none"
    ) {
      if (countContainer) {
        countContainer.textContent = countContainer.textContent.replace(
          /[\d]+/,
          resultCount,
        )
      }
      customTotalProduct.textContent = resultCount
    } else {
      const totalFromTemplates = parseInt(
        document
          .getElementById("CollectionTrueTotal")
          ?.getAttribute("data-collection-total") || "0",
        10,
      )
      const totalFromCount = parseLastPositiveInt(
        countContainer?.textContent || "",
      )
      const total = totalFromTemplates || totalFromCount || resultCount
      customTotalProduct.textContent = String(total)
    }
  }
  const totalResultsElem = customTotalProduct
  const totalResults = totalResultsElem
    ? parseInt(totalResultsElem.textContent, 10)
    : 0
  const finalWidth = totalResults ? (resultCount * 100) / totalResults : 0

  // Ensure finalWidth doesn't exceed 100%
  const progressBar = loadMoreProgressBar
  if (progressBar) {
    progressBar.style.width = `${Math.min(finalWidth, 100)}%`
  }
}
// Initial count
countTotalProduct()

// Event listener for load more button
if (loadMoreBtn) {
  loadMoreBtn.addEventListener("click", loadMoreProducts)
}

document.addEventListener("DOMContentLoaded", function () {
  const sortSelect = document.querySelector("#SortBy")
  if (sortSelect) {
    sortSelect.addEventListener("click", function () {
      console.log("Sort changed")
    })
  }
})
